import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'react-feather';
import { useDarkMode } from './DarkModeContext';

function Footer() {
    const { darkMode } = useDarkMode();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const calculateYearProgress = () => {
        const now = new Date();
        const start = new Date(now.getFullYear(), 0, 0);
        const diff = now - start;
        const oneDay = 1000 * 60 * 60 * 24;
        const dayOfYear = Math.floor(diff / oneDay);
        const progress = (dayOfYear / 365) * 100;
        return progress.toFixed(1);
    };

    const getDaysRemainingInYear = () => {
        const now = new Date();
        const endOfYear = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
        const diff = endOfYear - now;
        const oneDay = 1000 * 60 * 60 * 24;
        const daysRemaining = Math.ceil(diff / oneDay);
        return daysRemaining;
    };

    const footerLinkStyle = {
        color: darkMode ? '#e0e0e0' : '#333',
        textDecoration: 'underline',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
    };

    return (
        <footer style={{
            padding: '20px',
            borderTop: darkMode ? '1px solid #222529' : '1px solid #666',
            marginTop: '50px',
            backgroundColor: darkMode ? '#1a1a1a' : 'white',
            color: darkMode ? '#e0e0e0' : '#333'
        }}>
            {/* <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    opacity: '0.8',
                    fontSize: '14px',
                    color: darkMode ? '#e0e0e0' : '#333'
                }}>
                    <span>Year {new Date().getFullYear()} progression {isMobile ? '' : '(reminder to do the most)'}</span>
                    <span>{calculateYearProgress()}% complete</span>
                </div>
                <div style={{
                    width: '100%',
                    height: '4px',
                    backgroundColor: darkMode ? '#2A2B2F' : '#214B23',
                    borderRadius: '2px',
                    overflow: 'hidden',
                    position: 'relative'
                }}>
                    <div style={{
                        width: `${calculateYearProgress()}%`,
                        height: '100%',
                        backgroundColor: '#4CAF50',
                        borderRadius: '2px',
                        transition: 'width 0.3s ease'
                    }}/>
                </div>
                {parseFloat(calculateYearProgress()) > 50 && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '8px',
                        fontSize: '12px',
                        opacity: '1',
                        color: darkMode ? '#e0e0e0' : '#333'
                    }}>
                        <span style={{ color: '#4CAF50' }}>👆<span style={{opacity:'0.7'}}> experience</span></span>
                        <span>
                            {(() => {
                                const daysRemaining = getDaysRemainingInYear();
                                return daysRemaining < 50 ? `(${daysRemaining} days) ` : '';
                            })()}
                            <span style={{opacity:'0.7'}}>opportunity</span> ☝️
                        </span>
                    </div>
                )}
            </div> */}
            <div style={{textAlign:'center', marginTop:'20px', color: darkMode ? '#e0e0e0' : '#333'}}>
                <p style={{fontSize:'18px', marginTop:'0px', textAlign:'center'}}>Made with ♥️ and 🍕</p>
                <p style={{fontSize:'18px', marginTop:'0px', textAlign:'center'}}>© {new Date().getFullYear()} Merra.ai</p>
            </div>
            <div style={{textAlign:'center', marginTop:'14px'}}>
                <div style={{ fontSize: '14px', fontWeight: 800, opacity: darkMode ? 0.9 : 0.85 }}>
                    Use cases
                </div>
                <div style={{display:'flex', justifyContent:'center', gap:'14px', marginTop:'10px', flexWrap:'wrap'}}>
                    <Link to="/use-cases" style={footerLinkStyle}>Use cases index</Link>
                    <Link to="/ai-video-maker" style={footerLinkStyle}>AI video maker</Link>
                    <Link to="/ai-vlog-maker" style={footerLinkStyle}>AI vlog maker</Link>
                    <Link to="/ai-minivlog-maker" style={footerLinkStyle}>AI minivlog maker</Link>
                    <Link to="/ai-day-in-the-life-maker" style={footerLinkStyle}>Day in the life</Link>
                    <Link to="/ai-get-ready-with-me-maker" style={footerLinkStyle}>GRWM</Link>
                </div>
                <div style={{ fontSize: '14px', fontWeight: 800, opacity: darkMode ? 0.9 : 0.85, marginTop: '18px' }}>
                    Free tools
                </div>
                <div style={{display:'flex', justifyContent:'center', gap:'14px', marginTop:'10px', flexWrap:'wrap'}}>
                    <Link to="/tiktok-shadowban-checker" style={footerLinkStyle}>TikTok shadowban checker</Link>
                    <Link to="/instagram-shadowban-checker" style={footerLinkStyle}>Instagram shadowban checker</Link>
                    <Link to="/when-to-post-tiktok" style={footerLinkStyle}>When to post TikTok</Link>
                    <Link to="/when-to-post-instagram" style={footerLinkStyle}>When to post Instagram</Link>
                </div>
            </div>
            <div style={{display:'flex', justifyContent:'center', gap:'20px', marginTop:'40px', flexWrap:'wrap'}}>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/about" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        About
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/blog" 
                        target="_blank"
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Blog
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/blog/how-much-water-to-generate-one-video" 
                        target="_blank"
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        🌱 How much water one video uses
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/founder" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Founder
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/pricing" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Pricing
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/contact" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Contact
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/status" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Status
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/merra-or-manual" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Merra AI or Manual ? The Big Question
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/career" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Career
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/negotiation-brain-manifesto" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        The Negotiation Brain Manifesto
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/merra-comparison" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Comparison
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/confidentiality-rules" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Confidentiality Rules
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/privacy-policy" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Privacy Policy
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/terms-of-service" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Terms of Service
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/media-kit" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Press Kit & Media
                        <ExternalLink size={14} />
                    </Link>
                </p>
                <p style={{wordBreak:'break-word', margin: 0}}>
                    <Link 
                        to="/ambassador-programs" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={footerLinkStyle}
                    >
                        Make UGC content for Merra AI (and earn $$$)
                        <ExternalLink size={14} />
                    </Link>
                </p>
            </div>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <img 
                    src={`/memoji13.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px'}} 
                />
                <img 
                    src={`/memoji14.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
                <img 
                    src={`/memoji10.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
                <img 
                    src={`/memoji12.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
                <img 
                    src={`/memoji9.png`} 
                    alt="Memoji"
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
                <img 
                    src={`/memoji8.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
                <img 
                    src={`/memoji15.png`} 
                    alt="Memoji" 
                    style={{ marginTop: '30px', width: isMobile ? '30px' : '50px', height: isMobile ? '30px' : '50px', borderRadius: isMobile ? '15px' : '25px', marginLeft: isMobile ? '5px' : '10px'}} 
                />
            </div>
        </footer>
    );
}

export default Footer;

